(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("produckLib", [], factory);
	else if(typeof exports === 'object')
		exports["produckLib"] = factory();
	else
		root["produckLib"] = factory();
})(self, function() {
return 